module.exports = __webpack_public_path__ + "img/RUS.b1c379eb.png";